import { render, staticRenderFns } from "./RegistroNotaPep.vue?vue&type=template&id=131e4d5f&"
import script from "./RegistroNotaPep.vue?vue&type=script&lang=js&"
export * from "./RegistroNotaPep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports